import { InnovaSignal } from "@/client-admin/types.gen";
import { columns } from "./columns";
import { DataTable } from "./data-table";

type Props = {
  rows: InnovaSignal[];
};

export function SignalsTable({ rows }: Props) {
  return <DataTable columns={columns} data={rows} />;
}
